import React from "react";
import styles from "./agent-info-skeleton.module.scss";
import SkeletonC from "../../../stories/common/skeleton";

const AgentInfoSkeleton = () => {
  return (
    <div className={styles.agentInfo}>
      <SkeletonC width="100%" height="30px" />
      <div className={styles.agentWrap}>
        <SkeletonC shape="circle" size="6rem" className="mr-2" />

        <div style={{ width: "70%" , marginLeft:'10px'}}>
          <SkeletonC width="70%" height="25px" className={styles.skeleton} />
          <SkeletonC width="70%" height="25px" className={styles.skeleton} />
          <SkeletonC width="70%" height="25px" className={styles.skeleton}/>
        </div>
      </div>
    </div>
  );
};

export default AgentInfoSkeleton;
